import { Check } from "@mui/icons-material";
import { Box, Button, IconButton, Typography } from "@mui/material";
import { useMemo } from "react";
import { setReceptionStatusOfPatient } from "../../../api/area";
import CloseIcon from "../../../assets/SVG/closeIcon";
import CustomTable from "../../customTable/CustomTable";

export default function TableQarbal({
  rowData,
  areaId,
  handlePatientClick,
  moduleId,
  isReception,
  totalSize,
  pageable,
  setPageable,
}) {
  const [colDefs, defaultColDef] = useMemo(
    () => [
      [
        {
          field: "patientInfo.name",
          headerName: "نام و نام خانوادگی",
          width: 170,
        },
        {
          field: "patientInfo.phone",
          headerName: "شماره تلفن",
          width: 130,
        },
        {
          field: "patientInfo.fatherName",
          headerName: "نام پدر",
          width: 120,
        },
        {
          headerName: "بیمه",
          width: 140,
          cellRenderer: (x) => {
            return (
              <Typography
                key={`insurance_${x.id}`}
                fontFamily="Vazirmatn"
                sx={{ lineHeight: "unset" }}
              >
                {x?.data?.patientInfo?.insurance === "TAKMIL"
                  ? "تکمیلی"
                  : x?.data?.patientInfo?.insurance === "MILITARY"
                    ? "نیروهای مسلح"
                    : x?.data?.patientInfo?.insurance === "TAMIN"
                      ? "تامین اجتماعی"
                      : x?.data?.patientInfo?.insurance === "SALAMAT"
                        ? "سلامت"
                        : "ندارد "}{" "}
              </Typography>
            );
          },
        },
        {
          field: "patientInfo.identifier",
          headerName: "کد ملی",
          width: 120,
        },
        {
          field: "patientInfo.job",
          headerName: "شغل",
          width: 130,
        },
        {
          field: "patientInfo.patientNo",
          headerName: "شماره پرونده",
          width: 130,
        },
        {
          field: "createdAt",
          headerName: isReception ? "زمان پذیرش" : "زمان ارجاع",
          width: 140,
        },
        // {
        //   field: "patientInfo.birthDate",
        //   headerName: "تاریخ تولد",
        //   width: 150,
        //   cellRenderer: (x) => {
        //     return (
        //       <>
        //       <Typography fontFamily="Vazirmatn" >{x?.data?.patientInfo?.birthDate.split("-",2)[0]}</Typography>
        //       </>
        //     )}
        // },
        {
          headerName: "عملیات",
          width: 140,
          cellRenderer: (x) => {
            return (
              <Button
                sx={{ fontFamily: "Vazirmatn" }}
                variant="contained"
                key={`operation_${x.id}`}
                color={!isReception ? "primary" : "error"}
                onClick={() => {
                  if (!isReception) {
                    setReceptionStatusOfPatient(
                      areaId,
                      moduleId,
                      x.data?.patientInfo?.id,
                      true,
                    )
                      .then(() => {
                        handlePatientClick(false, x.data);
                      })
                      .catch(() => {});
                  } else {
                    setReceptionStatusOfPatient(
                      areaId,
                      moduleId,
                      x.data?.patientInfo?.id,
                      false,
                    )
                      .then(() => {
                        handlePatientClick(true, x.data);
                      })
                      .catch(() => {});
                  }
                }}
              >
                {!isReception ? "ثبت ورود" : "لغو ثبت ورود"}
              </Button>
            );
          },
        },
      ],
      {
        filter: true,
        editable: false,
      },
    ],
    [moduleId, areaId, isReception, handlePatientClick],
  );

  return (
    <>
      {rowData && (
        <>
          <CustomTable
            totalElements={totalSize}
            onPageChange={(pageIndex, pageSize) => {
              setPageable({
                pageIndex: pageIndex,
                pageSize: pageSize,
              });
            }}
            pageSize={pageable.pageSize}
            currentPage={pageable.pageIndex}
            columns={colDefs}
            defaultColDef={defaultColDef}
            rowData={rowData}
            onCellClicked={(e) => {
              if (e.value === false || e.value === true) {
                return;
              }
              window.open(
                `/parvandeh?areaId=${areaId}&patientIdentifier=${
                  e.data.patientInfo?.identifier
                }&patientIdentifierType=${
                  e.data.patientInfo?.identifierType
                }&patientId=${
                  e.data.patientInfo?.id
                }&moduleId=${moduleId}&tabName=${decodeURIComponent(
                  window.location.search.split("?", 3)[2],
                )}`,
                "_blank",
              );
            }}
          />
        </>
      )}
    </>
  );
}
